"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudiencesListResponseToJSON = exports.AudiencesListResponseFromJSONTyped = exports.AudiencesListResponseFromJSON = exports.instanceOfAudiencesListResponse = void 0;
var runtime_1 = require("../runtime");
var AudienceResponse_1 = require("./AudienceResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the AudiencesListResponse interface.
 */
function instanceOfAudiencesListResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudiencesListResponse = instanceOfAudiencesListResponse;
function AudiencesListResponseFromJSON(json) {
    return AudiencesListResponseFromJSONTyped(json, false);
}
exports.AudiencesListResponseFromJSON = AudiencesListResponseFromJSON;
function AudiencesListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'audiences': !(0, runtime_1.exists)(json, 'audiences') ? undefined : (json['audiences'].map(AudienceResponse_1.AudienceResponseFromJSON)),
    };
}
exports.AudiencesListResponseFromJSONTyped = AudiencesListResponseFromJSONTyped;
function AudiencesListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'audiences': value.audiences === undefined ? undefined : (value.audiences.map(AudienceResponse_1.AudienceResponseToJSON)),
    };
}
exports.AudiencesListResponseToJSON = AudiencesListResponseToJSON;
